// extracted by mini-css-extract-plugin
module.exports = {"customDrawer":"DocumentDrawer_customDrawer__1eVq_","content":"DocumentDrawer_content__2MzNp"};